<template>
  <div class="Custom container h-100">
    <div class="content">
      <div class="header">
        <el-row style="padding-top:10px">
          <el-col :span="19">
            <el-divider content-position="left">
              <el-link :underline="true" @click="initList">回款记录列表 <i class="el-icon-refresh"></i></el-link>
              <span style="margin-left: 20px;font-weight: 600">&nbsp;&nbsp;状态：</span>
              <el-checkbox-group v-model="searchCondition.claim_status" style="display: inline" @change="searchRecord">
                <el-checkbox :label="option.label" :value="option.value" v-for="(option,key) in claimStatusOption"
                             :key="key">
                  {{ option.value }}
                </el-checkbox>
              </el-checkbox-group>
            </el-divider>
          </el-col>
          <el-col :span="5" style="text-align: right">
            <el-button type="primary" size="mini" @click="dialogUploadVisible=true"
                       v-if="userAuth.can_import_pay_record">
              <i class="el-icon-upload el-icon--right"></i>&nbsp;导入回款记录
            </el-button>
            <el-button type="primary" class="el-button--operation" size="mini" @click="showSearch"
                       v-if="userAuth.can_search_pay_record"><i class="el-icon-search"/>&nbsp;筛选&nbsp;
            </el-button>
            <!--     导出       -->
            <pay-record-export v-permission="'can_import_pay_record'" :search="queryParams"
                               :before-export="handleSearchCondition" style="margin:0 10px"/>
          </el-col>
        </el-row>
        <div v-loading="loading"
             element-loading-text="回款记录加载中……"
             element-loading-spinner="el-icon-loading" class="default-table">
          <el-table
              :data="tableData"
              :height="tblHeight"
              :highlight-current-row="true"
              border>
            <el-table-column
                prop="claim_status"
                label="操作项"
                min-width="130" fixed="left" align="center">
              <template slot-scope="scope">
                <span><el-link type="primary" @click="claim(scope.row)"><i
                    class="el-icon-document"></i>详情</el-link></span>
                &nbsp; &nbsp;
                <span><el-link type="danger" @click="cancel(scope.row)"
                               :disabled="!([1,2,5].indexOf(scope.row.claim_status)>-1 && userAuth.can_cancel_pay_record)"><i
                    class="el-icon-delete"></i>撤销</el-link></span>
              </template>
            </el-table-column>
            <el-table-column
                prop="claim_status"
                label="状态"
                width="80" align="center">
              <template slot-scope="scope">
                <span :class="statusClass(scope.row.claim_status)">{{ scope.row.claim_status_alias }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="id"
                label="编号"
                width="80" align="center">
              <template slot-scope="scope">
                <span :title="`记录ID:${scope.row.id}`">{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="pay_date"
                label="收款日期"
                width="100">
              <template slot-scope="scope">
                <span :title="`记录ID:${scope.row.id}`">{{ scope.row.pay_date }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="payer"
                label="付款方名称"
                width="120"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="account"
                label="收款金额"
                width="120"
                header-align="center"
                align="right">
              <template slot-scope="scope">
                <span class="money">{{ moneyFormat(scope.row.account) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="sum_payment"
                label="认领金额"
                width="120"
                header-align="center"
                align="right">
              <template slot-scope="scope">
                <span class="money">{{ moneyFormat(scope.row.sum_payment) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="bank_account"
                label="银行账号"
                width="200"
                header-align="center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="bank_name"
                label="开户行"
                width="180"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="rec_name"
                label="收款方"
                width="140"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true"
            >
            </el-table-column>
            <el-table-column
                prop="pay_method"
                label="收款方式"
                width="100"
                header-align="center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="sellers"
                label="匹配销售"
                width="200"
                header-align="center"
                align="left"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="notify_at"
                label="通知已发"
                width="100"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="owmer_name"
                label="认领归属"
                width="100"
                header-align="center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="claim_at"
                label="认领时间"
                width="120"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="check_at"
                label="确认时间"
                width="120"
                header-align="center"
                align="center"
                :show-tooltip-when-overflow="true">
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="200"
                header-align="center"
                align="left" :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24" style="text-align: right">
              <el-pagination
                  v-if="initPaging"
                  :current-page="currentPage"
                  :page-sizes="pageSizes"
                  :page-size="pageSize"
                  :layout="defaultLayout"
                  :total="dataTotal"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--    筛选条件-->
    <el-drawer
        title="筛选条件"
        :visible.sync="showCondDrawer"
        :direction="direction">
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form ref="searchCondition" :model="searchCondition" label-width="80px">
            <el-form-item label="付款方：">
              <el-input v-model="searchCondition.payer" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：">
              <el-checkbox-group v-model="searchCondition.claim_status" style="display: inline" @change="searchRecord">
                <el-checkbox :label="option.label" :value="option.value" v-for="(option,key) in claimStatusOption"
                             :key="key">
                  {{ option.value }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="收款时间">
              <el-date-picker
                  v-model="searchCondition.time_value"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款月份">
              <el-date-picker
                  v-model="searchCondition.ym"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款方：">
              <el-input v-model="searchCondition.rec_name" clearable></el-input>
            </el-form-item>
            <!--            <el-form-item label="收款方式">-->
            <!--              <el-select v-model="searchCondition.pay_method" placeholder="请选择收款方式" clearable>-->
            <!--                <el-option-->
            <!--                    v-for="item in payMethodOptions"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="匹配销售">
              <UserSearch :name="searchKeyword" size="normal" style="width: 260px" clearable
                          @handleSelect="handleSelect"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" class="el-button--operation">筛选</el-button>
              <el-button @click="clearCondition">全部清除</el-button>
              <!--              <el-link :underline="false" style="font-size: 14px;margin-left: 8px;"-->
              <!--                       v-if="userAuth.can_import_pay_record" @click="exportExcel"><i class="el-icon-download"></i>&nbsp;&nbsp;导出-->
              <!--              </el-link>-->
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-drawer>
    <!--导入操作-->
    <el-dialog title="导入回款记录" :visible.sync="dialogUploadVisible" width="1300px">
      <el-row>
        <el-col :span="24">
          <el-upload
              class="upload-demo"
              :on-change="handleChange"
              :on-success="importSuccess"
              :headers="headerToken"
              name="file"
              :show-file-list="false"
              :file-list="file"
              :before-upload="beforeUpload"
              drag
              action="/api/pay_record/import"
              multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip"></div>
          </el-upload>
        </el-col>
      </el-row>

      <el-card class="box-card">
        <div slot="header" class="clearfix" style="text-align: left">
          <span style="font-weight: 800" title="PS:导入的excel文件请务必和模板列保持顺序，否则，会出现数据混乱的情况">导入模板：</span>
          <el-link type="primary" @click="downLoadTemplate" style="float: right; padding: 3px 0">模板下载.xlsx</el-link>
        </div>
        <el-row>
          <el-col>
            <el-table
                :data="templateData"
                style="width: 100%" class="data-table">
              <el-table-column
                  prop="pay_date"
                  label="收款日期"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="payer"
                  label="付款方名称"
                  min-width="200"
                  :show-tooltip-when-overflow="true">
              </el-table-column>
              <el-table-column
                  prop="account"
                  label="收款金额"
                  min-width="120"
                  header-align="center"
                  align="right">
                <template slot-scope="scope">
                  <span>{{ scope.row.account }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="bank_account"
                  label="银行账号"
                  min-width="200"
                  header-align="center"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="bank_name"
                  label="开户行"
                  min-width="200"
                  header-align="center"
                  align="center"
                  :show-tooltip-when-overflow="true">
              </el-table-column>
              <el-table-column
                  prop="rec_name"
                  label="收款方"
                  min-width="120"
                  header-align="center"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="pay_method"
                  label="收款方式"
                  min-width="100"
                  header-align="center"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="remark"
                  label="备注"
                  min-width="100"
                  header-align="center"
                  align="left">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>

      <el-form style="display: none">
        <el-form-item label="上传：">
          <el-upload
              action="/api/pay_record/import"
              :on-change="handleChange"
              :on-success="importSuccess"
              :headers="headerToken"
              name="file"
              :show-file-list="false"
              :file-list="file"
              :before-upload="beforeUpload"
          >
            <el-button type="primary" class="funcbars-button d-flex-row align-items-center import-btn">导入回款记录
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--    认领 -->
    <el-dialog
        title="回款记录详情"
        :visible.sync="dialogVisible"
        width="98%" style="min-height: 600px">
      <div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-card class="box-card-right">
              <div slot="header" class="clearfix">
                <span>回款确认( <span :class="statusClass(currentRecord.claim_status)">{{
                    currentRecord.claim_status_alias
                  }}</span>)</span>
                <span class="account">
                   <span style="font-weight: 500">收款金额：</span>
                  <span class="money">{{ moneyFormat(currentRecord.account) }}</span>
                </span>
                <span class="account">
                 <span style="font-weight: 500">认领金额：</span>
                  <span class="money">{{ moneyFormat(currentRecord.sum_payment) }}</span>
                </span>
                <span class="account">
                  <span style="font-weight: 800">收款方：</span>
                  <span>{{ currentRecord.rec_name || '--' }}</span>
                </span>
              </div>
              <el-row>
                <el-col :span="24">
                  <div class="default-table" v-loading="loadingSheet"
                       element-loading-text="详情加载中……"
                       element-loading-spinner="el-icon-loading">
                    <el-table
                        :data="paySheets" border>
                      <el-table-column
                          prop="check_status"
                          label="状态"
                          width="80" align="center">
                        <template slot-scope="scope">
                          <span :class="checkStatusClass(scope.row.check_status)">{{
                              scope.row.check_status_alias
                            }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="owner_id"
                          label="认领人"
                          align="center" width="80">
                        <template slot-scope="scope">
                          <span>{{ scope.row.owner_name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="created_at"
                          label="认领时间"
                          align="center" width="140" :show-tooltip-when-overflow="true">
                        <template slot-scope="scope">
                          <span>{{ scope.row.created_at }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="company_id"
                          label="乙方名称"
                          width="80" header-align="center" align="center" :formatter="companyFormat">
                      </el-table-column>
                      <el-table-column
                          prop="customer_name"
                          label="客户名称"
                          width="140" header-align="center" align="left">
                      </el-table-column>
                      <el-table-column
                          prop="contract_filed_alias"
                          label="合同归档"
                          width="100" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="contract_no"
                          label="合同编号"
                          width="100" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="contract_amount"
                          label="合同金额"
                          width="100" align="right" header-align="center">
                        <template slot-scope="scope">
                          <span>{{ moneyFormat(scope.row.contract_amount) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="invoice_status_alias"
                          label="开票状态"
                          width="120" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="created_date"
                          label="下单时间"
                          width="120" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="release_at"
                          label="要求发布时间"
                          width="120" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="bool_exec_alias"
                          label="是否执行" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="pay_status_alias"
                          label="回款状态" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="payment_account"
                          label="含税收入"
                          header-align="center"
                          align="right">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment_account) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="sum_amount"
                          label="剩余金额"
                          width="120"
                          header-align="center"
                          align="right"
                      >
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment_account - scope.row.sum_amount) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="payment"
                          label="本次回款金额"
                          width="120"
                          header-align="center"
                          align="right">
                        <template slot-scope="scope">
                          <span class="money">{{ moneyFormat(scope.row.payment) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="payment_remark"
                          label="认领备注"
                          header-align="center"
                          align="left">
                      </el-table-column>
                      <el-table-column
                          prop="artist_name"
                          label="红人名称"
                          align="center">
                      </el-table-column>
                      <el-table-column
                          prop="platforms"
                          label="平台" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="brand"
                          label="品牌" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="product"
                          label="产品/内容" align="center">
                      </el-table-column>
                      <el-table-column
                          prop="order_no"
                          label="订单编号"
                          align="center" width="160">
                        <template slot-scope="scope">
                          <to-order-detail :order="scope.row" :key="`order-no-${scope.row.order_no}`"
                                           by-field="order_no"/>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
              <br/>
              <br/>
              <div v-permission="'can_check_pay_sheet'"
                   style="display: flex;align-items: center;justify-content: space-between;">
                <el-button type="primary" @click="checkIt" v-if="[2,4,5].indexOf(currentRecord.claim_status)>-1">
                  &nbsp;&nbsp;确&nbsp;&nbsp;认&nbsp;&nbsp;回&nbsp;&nbsp;款&nbsp;&nbsp;
                </el-button>
                <el-button type="warning" plain @click="checkCancel"
                           v-if="[3,4].indexOf(currentRecord.claim_status)>-1">
                  &nbsp;撤回确认
                </el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {cancelCheckPaySheets, cancelPayRecord, checkPaySheets, getPayRecordList, getPaySheets} from "@/api/payRecord";
import {gFunc} from "@/globalFunc";
import {getOptionsForSelect} from "@/api/option";
import exportUrl from "@/components/commonTable/config";
import qs from 'qs';
import {getCompanyOptions} from "@/api/adOrder";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";
import PayRecordExport from "./components/export.vue";

export default {
  name: "payRecordIndex",
  components: {PayRecordExport, ToOrderDetail},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
    // 表格数据
    tableData() {
      return this.data
    },
    // ---- 分页相关配置 -------
    // 每页条数，切换
    pageSizes() {
      if (!(typeof (this.pagingData.page_size) === 'undefined') && this.pagingData.page_size < 10) {
        return [this.pagingData.page_size]
      }
      return [10, 15, 30, 50, 100, 200]
    },
    // 每一页大小，默认
    pageSize() {
      if (this.pagingData && !(typeof (this.pagingData.page_size) === 'undefined')) {
        return this.pagingData.page_size
      }
      return 10
    },
    // 初始化分页
    initPaging() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.is_show && this.pagingData.total > this.pageSize) {
          return true
        }
      }
      return false
    },
    // 数组总数
    dataTotal() {
      return this.pagingData.total
    },
    // 数据偏移量，分页序号使用
    dataOffset() {
      return typeof (this.pagingData.offset) === 'undefined' ? 0 : this.pagingData.offset
    },
    // 默认分页结构
    defaultLayout() {
      if (!(typeof (this.pagingData) === 'undefined')) {
        if (this.pagingData.layout) {
          return this.pagingData.layout
        }
      }
      return 'total, sizes, prev, pager, next, jumper'
    }
  },
  data() {
    return {
      dialogVisible: false,// 确认认领的数据
      currentRecord: {
        bank: '',
        pay_date: '',
        pay_method: '',
        account: 0,
        sum_payment: 0,
        claim_status_alias: '',
        claim_status: 0
      },//当前选中的记录
      paySheets: [],//回款记录确认信息
      loadingSheet: false,
      formOrder: {
        customer_name: '',
        artist_name: '',
        platforms: '',
        pro_content: '',
        pay_status: null,
        bool_exec: null
      },//订单筛选条件
      dialogUploadVisible: false,
      templateData: [
        {
          account: "38000.00",
          bank_account: "96100078801900000338",
          bank_name: "上海浦东发展银行股份有限公司展想广场支行",
          claim_at: null,
          claim_status: 1,
          created_at: "2021-03-16 16:05:24",
          id: 698,
          notify_at: null,
          owner_id: null,
          pay_date: "2021/03/15",
          pay_method: "银行收款",
          payer: "上海路捷鲲驰集团股份有限公司",
          rec_name: "缇苏文化支付宝manyizz@sina.com",
          remark: "测试",
          updated_at: "2021-03-16 16:05:24",
          user_id: 1,
        }
      ],
      file: [],
      uploadLoading: false,
      loading: false,//数据加载中
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 50
      },
      apePageSize: 0, // 用于组件切换了每一页数据后的显示
      currentPage: 1,
      data: [],
      showCondDrawer: false,
      direction: 'rtl',
      searchKeyword: '',
      searchCondition: {
        payer: '',
        claim_status: [],//1, 5, 2, 3, 4
        time_value: [],
        pay_method: '',
        rec_name: '',
        seller_id: null
      },
      queryParams: {},
      pay_methods: [],
      payMethodOptions: [
        // {value: '', label: '全部'},
        // {value: '银行收款', label: '银行收款'},
        // {value: '平台提现', label: '平台提现'},
        // {value: '支付宝', label: '支付宝'},
        // {value: '微信', label: '微信'},
        // {value: '银联', label: '银联'},
        // {value: '现金', label: '现金'},
      ],
      tblHeight: 800,
      claimStatusOption: [
        {value: '未认领', label: 1},
        {value: '部分认领', label: 5},
        {value: '已认领', label: 2},
        {value: '部分确认', label: 4},
        {value: '全部确认', label: 3},
        {value: '已撤销', label: -1},
      ],
      // 公司选项
      companyOption: [],
    }
  },
  created() {
    this.getCompanyOption()
    this.getTableSet()
    this.initList()
  },
  methods: {
    //公司ID格式化为公司名称
    companyFormat(row, column) {
      let current = this.companyOption.find(val => val.value === row[column.property])
      return current ? current.label : '--';
    },
    statusClass(status) {
      return status ? `claim_status_${status}` : 'claim_status_0'
    },
    checkStatusClass(check_status) {
      return check_status ? `check_status_${check_status}` : 'check_status_0'
    },
    moneyFormat(value) { // 金额 格式化
      return gFunc.numberFormat(value, 2, '.', ',', 'round')
    },
    importSuccess(response) {
      let that = this
      if (response.success) {
        that.showModal({
          h: that,
          text: "文件上传成功！导入" + response.model.total + '数据。',
          confirmText: "",
          cancelText: "",
          confirm: function () {
            that.initList()
            that.dialogUploadVisible = false
          }
        });

      } else {
        this.$message.warning(response.message);
      }
    },
    handleChange(file) {
      this.file = [file];
    },
    beforeUpload(file) {
      this.uploadLoading = true;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("导入文件大小不能超过 5MB!");
        this.uploadLoading = false
      }
      return isLt2M;
    },
    onSubmit() {
      this.showCondDrawer = false
      this.searchRecord()
    },
    clearCondition() {
      this.searchCondition = {
        payer: '',
        claim_status: [],
        time_value: [],
        pay_method: '',
        rec_name: '',
        seller_id: null
      }
      this.initList()
    },
    searchRecord() {
      this.currentPage = 1
      this.initList()
    },
    initList(type) {
      this.loading = true
      this.data = []
      const pagingInfo = this.getPagingInfo(type)
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      getPayRecordList(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          let pageData = res.model
          this.data = pageData.data
          this.pagingData.total = pageData.total * 1
          this.pagingData.page_size = pageData.per_page * 1
        }
      });
    },
    // pageSize 改变时处理
    handleSizeChange(val) {
      // this.pageSize = val
      this.apePageSize = val
      this.currentPage = 1
      this.initList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initList()
    },
    // 解决当前页数据全部删除完空白作用
    getPagingInfo(type = 'no_del') {
      if (type === 'del' && (this.pagingData.total - 1) <= (this.currentPage - 1) * this.pageSize) {
        this.currentPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : 1
      }
      const pagingInfo = {
        page_size: this.apePageSize ? this.apePageSize : this.pageSize,
        per_page: this.apePageSize ? this.apePageSize : this.pageSize,
        current_page: this.currentPage,
        page: this.currentPage

      }
      return pagingInfo
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.claim_status) {
        condition.claim_status = this.searchCondition.claim_status.join('|')
      }
      if (this.searchCondition.payer) {
        condition.payer = this.searchCondition.payer
      }
      if (this.searchCondition.pay_method) {
        condition.pay_method = this.searchCondition.pay_method
      }
      if (this.searchCondition.rec_name) {
        condition.rec_name = this.searchCondition.rec_name
      }
      if (this.searchCondition.ym) {
        condition.ym = this.searchCondition.ym
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      if (this.searchCondition.seller_id) {
        condition.seller_id = this.searchCondition.seller_id
      }
      this.queryParams = condition

      return condition
    },

    showSearch() {
      this.showCondDrawer = true
      // this.$nextTick(() => {
      //   if (this.payMethodOptions.length === 0)
      //     this.getOptions(['pay_methods'])
      // })
    },
    cancel(row) {
      this.$msgbox.confirm('此操作将撤销该回款记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelPayRecord({id: row.id}).then((res) => {
          if (res.success) {
            this.$message.success('操作成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    claim(row) {
      this.currentRecord = row
      this.dialogVisible = true
      this.paySheets = []
      this.$nextTick(() => {
        this.loadingSheet = true
        getPaySheets({record_id: this.currentRecord.id}).then((res) => {
          this.loadingSheet = false
          if (res.model) {
            this.paySheets = res.model.data
          }
        })
      })
    },
    checkIt() {
      let _this = this
      let ids = []
      this.paySheets.forEach((item) => {
        // 未确认的数据
        if (item.check_status === 0)
          ids.push(item.id)
      })
      let confirmText = "本次将确认回款认领记录：" + ids.length
      // 确认框
      this.showModal({
        h: this,
        text: "确定回款后将不能撤销，是否确认？<br/>" + confirmText,
        confirmText: '我确认',
        cancelText: "再想想",
        confirm: function () {
          _this.checkClaim();
        },
        cancel: function () {

        }
      });

    },
    checkClaim() {
      let ids = []
      this.paySheets.forEach((item) => {
        // 未确认的数据
        if (item.check_status === 0)
          ids.push(item.id)
      })
      checkPaySheets({record_id: this.currentRecord.id, ids: ids}).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.initList()
          this.dialogVisible = false

        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      if (item.id) {
        this.searchCondition.seller_id = item.id
      } else {
        this.searchCondition.seller_id = null
      }
    },
    downLoadTemplate() {
      //模板下载
      window.location.href = `/api/pay_record/template?token=${this.getToken()}`
    },
    //选项配置
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        let defOption = [{value: '', label: '全部'}];
        if (res.model) {
          this.payMethodOptions = res.model.pay_methods || [];
          this.payMethodOptions = [...defOption, ...this.payMethodOptions];
        } else {
          this.payMethodOptions = defOption
        }
      });
    },
    // 列表导出
    exportExcel() {
      const searchCondition = this.handleSearchCondition()
      const timestamp = new Date().getTime();
      const params = qs.stringify(searchCondition);
      let url = `${exportUrl}/api/pay_record/export?t=${timestamp}&token=${this.getToken()}&${params}`
      window.open(url)
    },
    getTableSet() {
      this.tblHeight = window.screen.availHeight - 220
    },
    //撤回确认操作
    checkCancel() {
      let _this = this
      let confirmText = "<span style='font-weight: lighter;font-size: 12px'>撤回后：可继续确认回款或者认领者也可以取消认领</span>"
      // 确认框
      this.showModal({
        h: this,
        text: "确定【撤回】已确认的认领记录？<br/>" + confirmText,
        confirmText: '我确认',
        cancelText: "再想想",
        confirm: function () {
          _this.cancelCheck()
        },
        cancel: function () {

        }
      });

    },
    //取消确认
    cancelCheck() {
      cancelCheckPaySheets({record_id: this.currentRecord.id}).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.initList()
          this.dialogVisible = false

        } else {
          this.$message.error(res.message)
        }
      })
    },
    async getCompanyOption() {
      await getCompanyOptions().then((res) => {
        if (res.success) {
          this.companyOption = res.data.options
        }
      })
    }
  }
}
</script>

<style scoped>

.funcbars-button {
  padding: 3px 8px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
}

.funcbars-button i {
  width: 14px;
  height: 14px;
  font-weight: bold;
  line-height: 1.4;
  margin-right: 5px;
}

.funcbars-button i svg {
  width: 100%;
  height: 100%;
  fill: rgb(254, 45, 84);
}

.funcbars-button-loadding {
  opacity: 0.5;
}

.import-btn {
  margin-right: 20px;
  background-color: #FF5722;
  color: #ffffff !important;
  border-color: #FF5722;
}

.import-btn:active {
  background-color: #f98846;
}

.import-btn > div > div {
  color: #ffffff !important;
}

/*
 card
 */

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix {
  text-align: left;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.account {
  margin-left: 20px;
  font-size: 1.2rem;
  font-weight: lighter;
}

/**
认领状态样式
 */
.claim_status_0 {

}

.claim_status_1 {
  color: #409EFF;
}

.claim_status_2 {
  color: #E6A23C;
  font-weight: bold;
}

.claim_status_3 {
  color: #67C23A;
  font-weight: bold;
}

.claim_status_4 {
  color: #67c23a;
  font-weight: lighter;
  font-style: initial;
}

.claim_status_5 {
  color: #E6A23C;
  font-weight: lighter;
  font-style: initial;
}


.claim_status_-1 {
  color: #909399;
}

/**
认领回款确认状态
 */
.check_status_0 {
  color: #409EFF;
}

.check_status_-1 {
  color: #909399;
}

.check_status_1 {
  color: #67C23A;
}
</style>
